<template>
    <div>
        <el-form :model="form" label-width="150px">
            <el-form-item label="姓名">
                <el-input v-model="form.userName"></el-input>
            </el-form-item>
            <el-form-item label="性别">
                <el-radio v-model="form.gender" label="男">男</el-radio>
                <el-radio v-model="form.gender" label="女">女</el-radio>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="form.mobile"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
                <el-input v-model="form.cardNumber"></el-input>
            </el-form-item>
            <el-form-item label="省份">
                <el-select v-model="form.province" value-key="name" @change="provinceChange">
                    <el-option v-for="item in globalData.provinceList" :key="item.id" :value="item" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="城市">
                <el-select v-model="form.city" value-key="name" @change="cityChange">
                    <el-option v-for="item in cityList" :key="item.id" :value="item" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="区县">
                <el-select v-model="form.county" value-key="name" @change="countyChange">
                    <el-option v-for="item in countyList" :key="item.id" :value="item" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="学校">
                <el-select v-model="form.school">
                    <el-option v-for="item in schoolList" :key="item.id" :value="item.name" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="年级">
                <el-select v-model="form.grade">
                    <el-option value="2016级" label="2016级"></el-option>
                    <el-option value="2017级" label="2017级"></el-option>
                    <el-option value="2018级" label="2018级"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="班级">
                <el-input v-model="form.classNumber"></el-input>
            </el-form-item>
            <el-form-item label="邮箱">
                <el-input v-model="form.email"></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
let that
export default {
    
    data(){
        return {
            form: {
               
            },
            provinceList:[],
            cityList: [],
            countyList: [],
            schoolList: []
        }
    },
    
    methods: {
        handleConfirm() {
            that.api.student.update(that.form).then(res => {
                that.$message.success(res.data)
                that.$dialog.close('modifyStudent')
            })
        },
        handleClick(){
            console.log('click',that.form)
        },
        provinceChange(value){
            this.api.district.findList(`parentId=${value.id}`).then(res => {
                this.form.province = value.name
                this.cityList = res.data
            })
        },
        cityChange(value){
            this.api.district.findList(`parentId=${value.id}`).then(res => {
                this.form.city = value.name
                this.countyList = res.data
            })
        },
        countyChange(value){
            this.api.district.findList(`parentId=${value.id}`).then(res => {
                this.form.county = value.name
                this.schoolList = res.data
            })
        }
    },
    mounted(){
        that = this
        that.form = that.globalData.student
        that.provinceList = that.globalData.provinceList
    }   
}
</script>

